/*
 * Notification that an error has occurred
 */
import * as React from "react";

import BaseToastNotification from "../components/base-toast-notification.tsx";

export default class ErrorNotification extends React.Component<{
    content: string | React.ReactElement;
}> {
    render(): React.ReactNode {
        const {content} = this.props;

        return (
            <BaseToastNotification isError={true}>
                {content}
            </BaseToastNotification>
        );
    }
}
